import { useHasPermission } from './useHasPermission';

/**
 * Element-Level Permission-Gate. Versteckt children wenn der Operator die
 * geforderten Permissions nicht hat. NIE als Security-Boundary verwenden —
 * der Backend ist die Wahrheit.
 */
export function HasPermission({ perms, anyOf, fallback = null, children }) {
  const ok = useHasPermission({ perms, anyOf });
  return ok ? children : fallback;
}
